import Styled from './AsLink.styled';

const { AsLink } = Styled;

export default AsLink;
